import { AxiosResponseHeaders } from 'axios';
import { AccountExtraitTransaction } from '../../entities/AccountExtraitTransaction';
import {
  AccountExtraitTransactionResponseDTO,
  AccountExtraitTransactionsServiceBody,
  AccountExtraitTransactions,
} from '../../entities/AccountExtraitTransaction/AccountExtraitTransactionResponseDTO';

const AccountExtraitTransactionResponseDTOtoTransactionAdapter = (
  response: AccountExtraitTransactionResponseDTO,
  headers?: AxiosResponseHeaders,
): AccountExtraitTransactions => {
  if (!response.body) {
    throw Error();
  }

  return {
    totalItems: (response.body as AccountExtraitTransactionsServiceBody).paginationTotal,
    transactions: response.body.transactions.map(
      transaction =>
        new AccountExtraitTransaction(
          transaction.transactionId,
          transaction.description,
          transaction.status,
          transaction.type,
          transaction.cancelledDate,
          transaction.executedDate,
          transaction.transactionDate,
          transaction.transactionValueDate,
          transaction.transactionUnit,
          transaction.transactionUser,
          transaction.transactionUserSerialNumber,
          transaction.amount,
          transaction.counterparty,
          transaction.paymentDetails,
          transaction.balance,
          (response.body as AccountExtraitTransactionsServiceBody).currency,
        ),
    ),
  };
};

export { AccountExtraitTransactionResponseDTOtoTransactionAdapter };
